"use strict";

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.object.define-properties");

require("core-js/modules/es7.object.get-own-property-descriptors");

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.array.filter");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}
/*
  buildReducer
  Consumes treble store and dynamically builds global state reducer.
*/


var buildReducer = function buildReducer(store) {
  var Reducer = function Reducer(state, action) {
    var subscribeID = state.subscribeID;
    var reducerActions = {
      'updateHistory': function updateHistory() {
        return _objectSpread({}, state, {
          history: action.updateHistory
        });
      },
      'updateSubscribeID': function updateSubscribeID() {
        return _objectSpread({}, state, {
          subscribeID: subscribeID + 1
        });
      }
    };
    store.map(function (item) {
      var objectProp = Object.keys(item.state)[0];
      var actionName = action[item.action];
      reducerActions = _objectSpread({}, reducerActions, _defineProperty({}, item.action, function () {
        return _objectSpread({}, state, _defineProperty({}, objectProp, actionName));
      }));
    });
    return reducerActions[action.type]();
  };

  return Reducer;
};

var _default = buildReducer;
exports["default"] = _default;
module.exports = exports["default"];